export default __webpack_public_path__ + "static/media/bag10.388d2f73.jfif";